<script setup>
import { useAppStore } from '../../composables/useAppStore'

const { openShiftForm } = useAppStore()

const items = [
  { to: '/', label: 'Главная', icon: 'home' },
  { to: '/shifts', label: 'Смены', icon: 'route' },
  { to: '/payouts', label: 'Выплаты', icon: 'wallet' },
  { to: '/analytics', label: 'Аналитика', icon: 'chart' },
  { to: '/settings', label: 'Настройки', icon: 'settings' }
]
</script>

<template>
  <nav class="fixed inset-x-0 bottom-0 z-40 px-3 pb-[calc(env(safe-area-inset-bottom,0px)+0.6rem)] sm:hidden" aria-label="Мобильная навигация">
    <button
      type="button"
      class="absolute right-5 -top-14 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-brand-500 text-white shadow-xl shadow-brand-500/35 ring-8 ring-app-bg transition active:scale-95"
      aria-label="Добавить смену"
      @click="openShiftForm()"
    >
      <svg class="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>
    </button>

    <div class="mx-auto max-w-md rounded-[1.5rem] border border-app-border bg-white/95 p-1.5 shadow-[0_16px_48px_rgba(15,23,42,0.18)] backdrop-blur-xl">
      <div class="grid grid-cols-5 gap-1">
        <RouterLink
          v-for="item in items"
          :key="item.to"
          :to="item.to"
          class="flex min-h-14 flex-col items-center justify-center gap-1 rounded-app-control px-1 py-1.5 text-[10px] font-black text-app-muted transition focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-slate-200"
          active-class="!bg-slate-950 !text-white"
        >
          <svg v-if="item.icon === 'home'" class="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"><path d="M3 10.5 12 3l9 7.5"/><path d="M5 10v10h14V10"/><path d="M9 20v-6h6v6"/></svg>
          <svg v-else-if="item.icon === 'route'" class="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"><path d="M6 19a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"/><path d="M18 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"/><path d="M6 13V8a3 3 0 0 1 3-3h6"/><path d="M18 11v5a3 3 0 0 1-3 3H9"/></svg>
          <svg v-else-if="item.icon === 'wallet'" class="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16v12H4z"/><path d="M4 7l3-3h13"/><path d="M16 13h4"/></svg>
          <svg v-else-if="item.icon === 'chart'" class="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"><path d="M4 19V5"/><path d="M4 19h16"/><path d="M8 16v-5"/><path d="M12 16V8"/><path d="M16 16v-9"/></svg>
          <svg v-else class="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.7 1.7 0 0 0 .34 1.88l.06.06-2.12 2.12-.06-.06a1.7 1.7 0 0 0-1.88-.34 1.7 1.7 0 0 0-1.03 1.55V20h-3v-.09A1.7 1.7 0 0 0 10.68 18.36a1.7 1.7 0 0 0-1.88.34l-.06.06-2.12-2.12.06-.06A1.7 1.7 0 0 0 7.02 15a1.7 1.7 0 0 0-1.55-1.03H5v-3h.47A1.7 1.7 0 0 0 7.02 9.94a1.7 1.7 0 0 0-.34-1.88L6.62 8l2.12-2.12.06.06a1.7 1.7 0 0 0 1.88.34A1.7 1.7 0 0 0 11.71 4.73V4h3v.73a1.7 1.7 0 0 0 1.03 1.55 1.7 1.7 0 0 0 1.88-.34l.06-.06L19.8 8l-.06.06a1.7 1.7 0 0 0-.34 1.88A1.7 1.7 0 0 0 20.95 11H21v3h-.05A1.7 1.7 0 0 0 19.4 15Z"/></svg>
          <span>{{ item.label }}</span>
        </RouterLink>
      </div>
    </div>
  </nav>
</template>
